import React, { useState } from "react";

// Small debug helper to display a truncated UUID-like identifier with a
// "copy to clipboard" button. Intended for super-admin debug surfaces.
//
// Props:
//   - value: the full string to copy
//   - prefixLength: number of leading chars to display (default 8)
//   - label: optional prefix label (e.g. "id_patient")
//   - title: optional tooltip / aria-label override
const CopyableId = ({ value, prefixLength = 8, label, title }) => {
  const [copied, setCopied] = useState(false);

  if (value === undefined || value === null || value === "") return null;
  const str = String(value);
  const short = str.length > prefixLength ? str.slice(0, prefixLength) : str;

  const handleCopy = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(str);
      } else {
        const ta = document.createElement("textarea");
        ta.value = str;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (err) {
      // best-effort, ignore
    }
  };

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontFamily: "monospace",
        fontSize: "0.85em",
        color: "#888",
      }}
      title={title || str}
    >
      {label ? <span style={{ color: "#aaa" }}>{label}:</span> : null}
      <span>{short}{str.length > prefixLength ? "…" : ""}</span>
      <button
        type="button"
        onClick={handleCopy}
        className="btn btn-link btn-sm"
        style={{
          padding: "0 4px",
          fontSize: "0.9em",
          lineHeight: 1,
          textDecoration: "none",
          color: copied ? "#4caf50" : "#1976d2",
        }}
        title={copied ? "Copied!" : "Copy full value"}
        aria-label={copied ? "Copied" : "Copy"}
      >
        {copied ? "✓" : "📋"}
      </button>
    </span>
  );
};

export default CopyableId;
